<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Justificativa da alteraçao do rateio pela UABS"
                @click.stop="mostrarDetalhe()"
            ></i>
        </span>
        <b-modal id="modalDetalhe" v-model="mostrarModalDetalhe">
            <div slot="modal-title">Justificativa da alteraçao do rateio pela UABS</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <b-form-textarea
                            v-model="item.justificativaAlteracaoRateio"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharDetalhe()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalhe: false,
            mensagem: ''
        }
    },

    methods: {
        mostrarDetalhe() {
            this.mostrarModalDetalhe = true
        },

        fecharDetalhe() {
            this.mostrarModalDetalhe = false
        }
    },

    computed: {
        mostrarIcone() {
            return this.item != null
                && this.item.justificativaAlteracaoRateio != null 
        }
    }
}
</script>
